export default {
  // Page title
  title: "Inbox Management",
  stationLetter: "Inbox Messages",
  autoConfig: "Auto-send Configuration",
  autoConfigMessage: "Auto-send Message Log",

  // Search form
  recipient: "Member Account",
  recipientPlaceholder: "Enter member account",
  subject: "Subject",
  subjectPlaceholder: "Enter subject",
  status: "Status",
  statusPlaceholder: "Select status",
  sendTime: "Operation Time",
  statisticsDate: "Statistics Date",
  search: "Search",
  reset: "Reset",
  export: "Export",

  // Status
  unread: "Unread",
  read: "Read",
  deleted: "Deleted",
  
  // Task Status
  taskStatus: "Task Status",
  statusNotSent: "Not Sent",
  statusSending: "Sending",
  statusSent: "Sent",
  
  // Operation
  operationTime: "Operation Time",
  operator: "Operator",
  agentMembers: "Agent Members",
  startTime: "Start Time",
  endTime: "End Time",
  memberType: "Member Type",

  // Table columns
  content: "Content",
  language: "Language",
  receiveTime: "Received Time",
  sender: "Operator",
  messageType: "Message Type",

  // Messages
  exporting: "Exporting...",
  exportSuccess: "Export successful",
  exportFailed: "Export failed",
  operationFailed: "Operation failed",
  requestFailed: "Request failed",

  // Other
  seeDetails: "View",

  // Send message modal
  sendMessage: "Send Inbox Message",
  language_label: "Select Language:",
  recipient_label: "Member Account",
  designatedMembers: "Designated Members",
  allMembers: "All Members",
  agent: "Agent under members",
  designatedVipMembers: "Designated VIP Members",
  directCustomers: "Direct Customers",
  importUsernames: "Import Usernames",
  agentLabel: "Agent:",
  selectAgent: "Select agent",
  vipLevelLabel: "VIP Level:",
  selectVipLevel: "Select VIP level",
  membersLabel: "Select Members:",
  memberPlaceholder: "Search and select members",
  membersRequired: "Please select members",
  usernamesLabel: "Import Usernames:",
  usernamesPlaceholder: "Enter usernames, multiple separated by comma or new line",
  usernamesRequired: "Please enter or import usernames",
  titleLabel: "Subject:",
  titlePlaceholder: "Within 50 characters",
  titleRequired: "Please enter subject",
  summaryLabel: "Summary",
  summaryPlaceholder: "Enter summary, up to 200 characters",
  coverImageLabel: "Cover Image",
  titleMaxLength: "Subject must not exceed 50 characters",
  contentLabel: "Content:",
  contentRequired: "Please enter content",
  contentMaxLength: "Content must not exceed 1000 characters",
  contentCharLimit: "Content character limit: 1000",
  sendSuccess: "Send successful",
  sendFailed: "Send failed",

  // Status options
  statusUnread: "Unread",
  statusRead: "Read",
  statusDeleted: "Deleted",

  // Target user count
  targetUsers: "Target Users",
  downloadTemplate: "Download Template",

  // Message type
  messageType_label: "Message Type:",
  messageType_system: "System Message",
  messageType_promos: "Promotional Message",
  messageType_updates: "Platform Message",

  // Auto-send configuration
  autoConfigTitle: "Add Auto-send Template",
  autoConfigTitle_edit: "Edit Auto-send Template",
  templateCode_label: "Target Type:",
  templateCode_placeholder: "Select target type",
  templateCode_required: "Please select target type",
  registerUsers: "New Registered Users",
  firstRechargeUsers: "First Recharge Users",
  title_label: "Title:",
  title_placeholder: "Within 50 characters",
  title_required: "Please enter title",
  title_maxLength: "Title must not exceed 50 characters",
  recipient_type_label: "Member Account:",
  allMembers_label: "All Members",
  agent_label: "Agent",
  agent_select_label: "Agent:",
  agent_placeholder: "Select agent",
  agent_required: "Please select agent",
  messageType_type_label: "Message Type:",
  messageType_placeholder: "Select message type",
  messageType_required: "Please select message type",
  content_label: "Content:",
  content_required: "Please enter content",
  content_maxLength: "Content must not exceed 1000 characters",
  autoConfig_search: "Search",
  autoConfig_reset: "Reset",
  autoConfig_add: "Add",
  autoConfig_edit: "Edit",
  autoConfig_enable: "Enable",
  autoConfig_delete: "Delete",
  autoConfig_templateName: "Template Title",
  autoConfig_targetType: "Target Type",
  autoConfig_status: "Status",
  autoConfig_language: "Language",
  autoConfig_content: "Content",
  autoConfig_operator: "Operator",
  autoConfig_actions: "Actions",
  autoConfig_disabled: "Disabled",
  autoConfig_enabled: "Enabled",
  autoConfig_disable: "Disable",
  autoConfig_all: "All",
  autoConfig_enableSuccess: "Enabled successfully",
  autoConfig_disableSuccess: "Disabled successfully",
  autoConfig_deleteSuccess: "Deleted successfully",
  autoConfig_deleteFailed: "Delete failed",
  autoConfig_operationFailed: "Operation failed",
  autoConfig_editSuccess: "Updated successfully",
  autoConfig_editFailed: "Update failed",
  autoConfig_createSuccess: "Created successfully",
  autoConfig_createFailed: "Create failed",
  
  // Placeholder related
  placeholder_availablePlaceholders: "Available Placeholders",
  placeholder_noPlaceholders: "No placeholders available",
  placeholder_example: "Example",
  placeholder_insertToTitle: "Insert to Title",
  placeholder_insertToContent: "Insert to Content",
  placeholder_tip: "Tip: Click placeholder to copy, hover to view details and insert options",
  placeholder_copied: "Copied to clipboard",
  placeholder_copyFailed: "Copy failed",
  placeholder: {
    memberAccount_desc: "Member Account",
    currency_desc: "Currency"
  },
  
  // Statistics page
  stats_serialNumber: "Serial Number",
  stats_targetType: "Target Type",
  stats_memberType: "Member Type",
  stats_statisticsTime: "Statistics Time",
  stats_received: "Received",
  stats_readCount: "Read Count",
  stats_unreadCount: "Unread Count",
  stats_readRate: "Read Rate",
  startDate: "Start Date",
  endDate: "End Date"
};
